import React from 'react'
import { IoChevronBackCircle } from 'react-icons/io5';
import { useCustomNavigate } from 'ReusableFunctions/CustomHooks'

const EventRegister = () => {
    const pageRender = useCustomNavigate();

    return (
        <div className="homePage-backgroundColor event_rigistration_height overflow-hidden py-4 pb-5">
            <div className="container h-100">
                <div className="col-5 col-md-3 col-lg-2 mb-3">
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 w-100 py-2"
                        onClick={() => pageRender("/professional/community")}
                    >
                        <IoChevronBackCircle className="fs-5" /> Back
                    </button>
                </div>

                <div className="frame_container">
                    {/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSewfqbtC7MQ3IvsNvLV_R88Ias0ziqW5Jr9bsm0f8oKQDwhBA/viewform?embedded=true" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}

                    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSea-qwWS2r5RNe4NNlQZ4XbCChNdKaPmnqNFD8hPIgPFaan7g/viewform?embedded=true" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </div>
            </div>
        </div>
    )
}

export default EventRegister